import { emailAddressFormLogic } from "../../form/logic";
import { GenericForm, GenericFormLogic } from "../../hooks";

export interface OneTimePasswordForm_SendCode extends GenericForm {
  email?: string;
}

export interface OneTimePasswordFormApp_SendCode {}

export const OneTimePasswordFormLogic_SendCode: GenericFormLogic<
  OneTimePasswordForm_SendCode,
  OneTimePasswordFormApp_SendCode
> = {
  email: emailAddressFormLogic({ required: true }),
} as const;

export const OneTimePasswordFormInitialState_SendCode =
  (): OneTimePasswordForm_SendCode => ({});
